import PropTypes from 'prop-types';
import Button from 'infrastructure/js/components/controls/Button/button';

import './buttonsCell.scss';

const ButtonsCell = ({ value = null}) => {

  if (!value || value.length === 0) {
    return null;
  }

  return (
    <div className="buttons-cell">
      {value.map((button, index) => {
        return (
          <Button key={index}
                  id={button.id || `buttonsCellBtn${index}`}
                  className={`btn small-btn ${button.className || ''}`}
                  disabled={button.disabled}
                  onClick={button.onClickHandler}
          >
            {button.label}
          </Button>
        );
      })}
    </div>
  );
};

ButtonsCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClickHandler: PropTypes.func.isRequired,
  })),
};


export default ButtonsCell;
